import { IonSkeletonText } from '@ionic/react'
import React from 'react'
import PageWrapper from '../../../../wrappers/pageWrapper/PageWrapper'

export const NotificationSettingsSkeleton: React.FC = () => {
	return (
		<PageWrapper page='notificationSettings' appBarOptions={{ backPath: '/settings' }}>
			<div className='options'>
				<div className='flex pb-[0.6rem] justify-end gap-1 pr-[14px] items-center text-center'>
					<div className='w-[72px]' />
					<div className='w-[72px]' />
				</div>
				{Array.from({ length: 7 }).map((_, i) => (
					<div
						key={i}
						className='row border-t border-text-grey-100 dark:border-brand-secondary-200-dark flex justify-between items-center pr-[14px]'
					>
						<IonSkeletonText animated className='rounded m-0 h-[1rem] w-[8rem]' />
						<div className='flex gap-1'>
							<div className='w-[72px] flex justify-center'>
								<IonSkeletonText animated className='rounded m-0 h-[1.25rem] w-[1.25rem]' />
							</div>
							<div className='w-[72px] flex justify-center'>
								<IonSkeletonText animated className='rounded m-0 h-[1.25rem] w-[1.25rem]' />
							</div>
						</div>
					</div>
				))}
			</div>
		</PageWrapper>
	)
}
